import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { FilterOptionLicense } from 'src/models/FilterMetric';

import { getRenderValue } from 'src/components/Inputs/DropdownCheckbox/dropdownCheckboxHelpers';

export const licenseInitialFilter = (
  loggedUserRole: string,
  licenses: GeneralCatalogItem[],
): FilterOptionLicense => {
  // If the user type is AGE save in the filter license state the current license list, to select all in DropDownCheckboxes
  if (loggedUserRole === 'AGE') {
    const currentlicense = licenses.map(({ code }) => code);
    const description = getRenderValue(currentlicense, currentlicense.length);
    return {
      description,
      queryKey: currentlicense.join(','),
    };
  }
  return {
    description: '',
    queryKey: '',
  };
};

export default licenseInitialFilter;
